"use client"

import Image from "next/image"
import { X } from "lucide-react"
import { useState } from "react"

import { Button } from "@/components/ui/button"

export type LightboxItem = {
  src: string
  alt: string
  caption?: string
}

export function MediaLightboxIsland({ items }: { items: LightboxItem[] }) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null)
  const active = activeIndex === null ? null : items[activeIndex]

  return (
    <>
      <div className="grid gap-3 sm:grid-cols-3">
        {items.map((item, index) => (
          <button key={item.src} type="button" onClick={() => setActiveIndex(index)} className="group relative h-44 overflow-hidden rounded-card bg-muted text-left">
            <Image src={item.src} alt={item.alt} fill sizes="(min-width: 640px) 33vw, 100vw" className="object-cover transition-transform duration-500 group-hover:scale-105" />
            {item.caption && <span className="absolute inset-x-3 bottom-3 text-sm font-medium text-background drop-shadow">{item.caption}</span>}
          </button>
        ))}
      </div>
      {active && (
        <div className="fixed inset-0 z-50 grid place-items-center bg-foreground/80 p-4 backdrop-blur-sm" role="dialog" aria-modal="true">
          <div className="relative h-[70vh] w-full max-w-5xl overflow-hidden rounded-panel bg-background shadow-elegant">
            <Image src={active.src} alt={active.alt} fill sizes="100vw" className="object-cover" />
            <Button type="button" size="icon" variant="secondary" className="absolute right-4 top-4 rounded-full" onClick={() => setActiveIndex(null)} aria-label="Close image">
              <X className="size-4" />
            </Button>
          </div>
        </div>
      )}
    </>
  )
}